interface DescriptionTabProps {
  description: string
}

export function DescriptionTab({ description }: DescriptionTabProps) {
  return (
    <div
      className='max-w-none'
      // biome-ignore lint/security/noDangerouslySetInnerHtml: <woo commerce returns html descriptions>
      dangerouslySetInnerHTML={{ __html: description }}
    />
  )
}
